import { render, staticRenderFns } from "./PortabilityInformation.vue?vue&type=template&id=288f0be0&scoped=true"
import script from "./PortabilityInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortabilityInformation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PortabilityInformation.vue?vue&type=style&index=0&id=288f0be0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288f0be0",
  null
  
)

export default component.exports